import { useState } from "react";
import NavBar from "../components/navBar";
import HomeComponent from "../components/homeComponent";
import Services from "../components/services";
import Contact from "../components/contact";
import LowBar from "../components/lowBar";

export default function Home() {
  const [activeTab, setActiveTab] = useState("home");

  const renderContent = () => {
    switch (activeTab) {
      case "home":
        return <HomeComponent />;
      case "services":
        return <Services />;
      case "contact":
        return <Contact />;
      default:
        return null;
    }
  };

  return (
    <div className="layout">
      <NavBar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="homeBody">{renderContent()}</div>
      <LowBar />
    </div>
  );
}
